import LocalizedStrings from "react-localization";

export const mappingKeysStrings = new LocalizedStrings({
  en: {
    title: "Mapping keys",
    viewCreativesButton: "View creatives",
    filterButton: "Filters",
    exportButton: "Export",
    resetFiltersButton: "Reset",
    socialAccountName: "Account name",
    socialAccountFriendlyName: "Friendly name",
    mappingStatus: "Mapping",
    product: "Product",
    firstOccurrence: "Date",
    totalSpend: "Spends",
    thresholdSpend: "Threshold Spends",
    totalImpressions: "Impressions",
    errors: {
      FieldRequired: "There are no social accounts selected for locking.",
      LinesMissingOrLocked:
        "The social account you selected is locked or not found.",
      LockingNotAllowed: "There was an error, while locking the lines.",
      UnlockingNotAllowed: "There was an error, while unlocking the lines.",
      TotalResultsExceedsMaxAllowed:
        "There are more than 10 000 results. Please refine your search.",
    },
    socialAccountPage: "Social account page",
  },
  fr: {
    title: "Clés de Mapping",
    viewCreativesButton: "Voir les créations",
    filterButton: "Filtres",
    exportButton: "Exporter",
    resetFiltersButton: "Réinitialiser",
    socialAccountName: "SAN",
    socialAccountFriendlyName: "SAFN",
    mappingStatus: "Mapping",
    product: "Produit",
    firstOccurrence: "Date",
    totalSpend: "Dépenses",
    thresholdSpend: "Seuil de dépenses",
    totalImpressions: "Impressions",
    errors: {
      FieldRequired:
        "Aucun Social Account n'a été sélectionné pour le verrouillage.",
      LinesMissingOrLocked:
        "Le Social Account que vous avez sélectionné est verrouillé ou introuvable.",
      LockingNotAllowed:
        "Une erreur s'est produite lors du verrouillage des lignes.",
      UnlockingNotAllowed:
        "Une erreur s'est produite lors du déverrouillage des lignes.",
      TotalResultsExceedsMaxAllowed:
        "Il y a plus de 10 000 résultats. Veuillez affiner votre recherche.",
    },
    socialAccountPage: "Page du Social Account",
  },
});
